import { EnrolmentNotInScopeReason } from '@studyportals/sp-lord-business-interface';
import ReviewReasonFactory from '@/models/review-reason-factory';
import { EnrolmentReviewState } from './enrolment-review-state';

export class NoPayReasonsReviewState extends EnrolmentReviewState {
	public display(): void {
		this.review.popups.showAdditionalNoPayReasonsSelectionPopup();
	}

	public requiresAdditionalInput(): boolean {
		return true;
	}

	public next(): void {
		if (this.includesOtherReason()) {
			this.review.changeAvailableReviewReasons(ReviewReasonFactory.obtainNoCommissionReasons());
			this.review.transitionTo(this.review.createReviewReasonSelectionState());
			return;
		}

		// "Other" was deselected after a reason was picked (e.g. via back navigation): the reason no longer applies.
		this.review.changeReviewReason(undefined);
		this.review.transitionTo(this.review.createTriggerPayloadReviewState());
	}

	public canPerformNext(): boolean {
		return this.review.selectedTriggerPayload.successFeeInformation.noPayReasons.length > 0;
	}

	private includesOtherReason(): boolean {
		return this.review.selectedTriggerPayload.successFeeInformation.noPayReasons.some(
			(_) => _.type === EnrolmentNotInScopeReason.OTHER
		);
	}
}
